module.exports = __webpack_public_path__ + "img/area_1.a8f5ce42.png";